import {
  axios,
  config
} from '../api'

let fun = {}

// 文件上传，传递类型和文件流，一次只能上传一个,上传成功Data包含文件的saveName
fun.uploadFile = (_outType,_type) => {
  return axios('post', config.API_URL + '/api/Pub/UploadFile', {
    outType: _outType, //商铺添加页面传递shop，用户添加页面传递customer
    type: _type //类型，商铺图片或营业执照，用户页面不传递
  })
}

// 文件下载或预览
fun.downLoadFile = (_saveName) => {
  return axios('post', config.API_URL + '/api/Pub/DownLoadFile',{}, {
    saveName: _saveName, //上传成功会取得saveName，拼接为接口的querystring
  },1)
}

export default fun



